<template>
  <div class="seek_detail_page">
    <div class="top-container flex_between">
      <div class="flex_center" style="cursor: pointer" @click="back">
        <i class="el-icon-arrow-left" />
        <div class="split"></div>
        {{ $t("part.viewDetail") }}
      </div>
      <div>
        <el-button
          class="primary-btn"
          size="small"
          type="primary"
          @click="back"
          >{{ $t("operate.backList") }}</el-button
        >
      </div>
    </div>
    <div class="status-container">
      <div>
        {{ $t("climant.climantNumber") }}：{{ claimant.claimStatementNum }}
      </div>
      <div class="status">
        {{ $t("climant.status") }}：
        <span v-if="claimant.status === 0">
          <!-- 待提交 -->
          {{ $t("climant.noSubmit") }}
        </span>
        <span
          v-else-if="
            claimant.status === 1 ||
            claimant.status === 3 ||
            claimant.status === 4 ||
            claimant.status === 15 ||
            claimant.status === 16 ||
            claimant.status === 17 ||
            claimant.status === 18 ||
            claimant.status === 21
          "
        >
          <!-- 待审核 -->
          {{ $t("cart.audit") }}
        </span>
        <span v-else-if="claimant.status === 19">
          <!-- 已通过：待确认（责任主体） -->
          {{ $t("home.passed") }}
        </span>
        <span v-else-if="claimant.status === 2">
          <!-- 驳回（预审） -->
          {{ $t("climant.rejected") }}
        </span>
        <span v-else-if="claimant.status === 5">
          <!-- 已拒赔 -->
          {{ $t("climant.claimsRejected") }}
        </span>
        <span v-else-if="claimant.status === 11">
          <!-- 待结算 -->
          {{ $t("climant.djs") }}
        </span>
        <span v-else-if="claimant.status === 12">
          <!-- 已结算 -->
          {{ $t("climant.settleAccounts") }}
        </span>
        <span v-else-if="claimant.status === 13">
          <!-- 已取消 -->
          {{ $t("home.canceled") }}
        </span>
        <span v-else-if="claimant.status === 14">
          <!-- 已撤回 -->
          {{ $t("climant.ych") }}
        </span>
      </div>
      <el-button
        v-if="pageIndex === 'detail'"
        class="btn"
        style="color: #bd3124"
        type="text"
        @click="handleViewRecord('record')"
        >{{ $t("climant.viewRecord") }}</el-button
      >
    </div>

    <div v-if="pageIndex === 'detail'" class="form_info">
      <el-form :inline="true" :model="claimant">
        <!-- 车辆基本信息 -->
        <div class="hearder-title">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            {{ $t("seek.basic") }}
          </div>
        </div>
        <div class="form-container">
          <!-- VIN -->
          <el-form-item :label="$t('seek.vin')">
            <el-input disabled v-model="claimant.vin"></el-input>
          </el-form-item>
          <!-- 品牌 -->
          <el-form-item :label="$t('home.brand')">
            <el-input disabled v-model="claimant.carBrand"></el-input>
          </el-form-item>
          <!-- 车型 -->
          <el-form-item :label="$t('home.carType')">
            <el-input disabled v-model="claimant.carModel"></el-input>
          </el-form-item>
          <!-- 车辆属性 -->
          <el-form-item :label="$t('climant.carAttribute')">
            <el-select disabled v-model="claimant.carAttribute" filterable clearable>
              <el-option :label="$t('climant.ryc')" :value="0"> </el-option>
              <el-option :label="$t('climant.ddc')" :value="1"> </el-option>
            </el-select>
          </el-form-item>
          <!-- 发动机号 -->
          <el-form-item :label="$t('seek.engineNUmber')">
            <el-input disabled v-model="claimant.engineNumber"></el-input>
          </el-form-item>
          <!-- 发动机型号/电机型号 -->
          <el-form-item :label="$t('seek.engineModel')">
            <el-input disabled v-model="claimant.engineModel"></el-input>
          </el-form-item>
          <!-- 电机号 -->
          <el-form-item :label="$t('climant.djNumer')">
            <el-input disabled v-model="claimant.motorModel"></el-input>
          </el-form-item>
          <!-- 行驶里程 -->
          <el-form-item :label="$t('seek.distance')">
            <el-input-number
              disabled
              class="number-input"
              :controls="false"
              :precision="0"
              v-model="claimant.roadHaul"
            >
            </el-input-number>
            <div class="number-input-append">km</div>
            <!-- <el-input disabled v-model="claimant.roadHaul">
              <template slot="append">KM</template>
            </el-input> -->
          </el-form-item>
          <!-- 生产日期 -->
          <el-form-item :label="$t('seek.produceDate')">
            <el-date-picker
              disabled
              type="date"
              value-format="yyyy-MM-dd"
              v-model="claimant.productionDate"
            ></el-date-picker>
          </el-form-item>
          <!-- 购车日期 -->
          <el-form-item :label="$t('seek.buyDate')">
            <el-date-picker
              disabled
              type="date"
              value-format="yyyy-MM-dd"
              v-model="claimant.salesDate"
            ></el-date-picker>
          </el-form-item>
          <!-- 零部件专业 -->
          <el-form-item
            :label="$t('climant.partMajor')"
            v-show="claimant.lbjzy"
          >
            <el-select disabled v-model="claimant.lbjzy" placeholder=" " filterable clearable>
              <el-option :label="$t('climant.carBody')" :value="1"> </el-option>
              <el-option :label="$t('climant.chassis')" :value="2"> </el-option>
              <el-option :label="$t('climant.electricalAppliances')" :value="3">
              </el-option>
              <el-option
                :label="$t('climant.interiorAndExteriorDecoration')"
                :value="4"
              >
              </el-option>
              <el-option :label="$t('climant.newEnergy')" :value="5">
              </el-option>
              <el-option :label="$t('climant.power')" :value="6"> </el-option>
            </el-select>
          </el-form-item>
        </div>
        <!-- 车辆故障信息 -->
        <div class="hearder-title">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            {{ $t("climant.hitchInfo") }}
          </div>
        </div>
        <div class="form-container">
          <!-- 发生日期 -->
          <el-form-item :label="$t('seek.happenDate')">
            <el-date-picker
              disabled
              type="date"
              value-format="yyyy-MM-dd"
              v-model="claimant.happenDate"
            ></el-date-picker>
          </el-form-item>
          <!-- 问题类别 -->
          <el-form-item :label="$t('seek.wtlb')">
            <el-select disabled v-model="claimant.questionType" filterable clearable>
              <el-option :label="$t('seek.khPDI')" value="客户PDI"> </el-option>
              <el-option :label="$t('seek.zdkh')" value="终端客户"> </el-option>
<!--              <el-option :label="$t('seek.gkjy')" value="港口救援"> </el-option>-->
            </el-select>
          </el-form-item>
          <!-- 维修方案 -->
<!--          <el-form-item :label="$t('climant.wxfa')">-->
<!--            <el-select v-model="claimant.repairPlan" disabled placeholder="" filterable clearable>-->
<!--              <el-option :label="$t('climant.wx')" :value="0"> </el-option>-->
<!--              <el-option :label="$t('climant.gh')" :value="1"> </el-option>-->
<!--            </el-select>-->
<!--          </el-form-item>-->
          <!-- 故障现象 -->
          <div class="fanyi-box">
            <el-form-item :label="$t('climant.hitchAppearance')">
              <el-input
                disabled
                type="textarea"
                v-model="claimant.symptom"
                style="width: 670px"
              ></el-input>
            </el-form-item>
          </div>
          <!-- 故障初步原因 -->
          <div class="fanyi-box">
            <el-form-item :label="$t('climant.hitchReson')">
              <el-input
                disabled
                type="textarea"
                v-model="claimant.preliminaryCauseOfFailure"
                style="width: 670px"
              ></el-input>
            </el-form-item>
          </div>

          <!-- 故障处理方案 -->
          <div class="fanyi-box">
            <el-form-item :label="$t('climant.hitchPlan')">
              <el-input
                disabled
                type="textarea"
                v-model="claimant.processingScenarios"
                style="width: 670px"
              ></el-input>
            </el-form-item>
          </div>
        </div>

        <!-- 故障件信息 -->
        <div class="hearder-title">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            {{ $t("climant.gzjxxl") }}
          </div>
        </div>
        <!-- 主因故障件 -->
        <div class="second-title">{{ $t("climant.mainFault") }}</div>
        <div class="form-container">
          <!-- 故障件件号 -->
          <el-form-item :label="$t('climant.faultNo')">
            <el-input disabled v-model="claimant.faultPartNumber"></el-input>
          </el-form-item>
          <!-- 故障件名称 -->
          <el-form-item :label="$t('climant.faultName')">
            <el-input disabled v-model="claimant.faultPartName"></el-input>
          </el-form-item>
          <!-- 故障件单价 -->
          <el-form-item :label="$t('climant.faultPrice')">
            <el-input-number
              disabled
              class="prepend-input"
              v-model="claimant.faultPartUnitPrice"
              :controls="false"
              :precision="2"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimant.currency === 0 ? "￥" : "" }}
              {{ claimant.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 纸箱号 -->
<!--          <el-form-item :label="$t('claimantKd.zxh')">-->
<!--            <el-input disabled v-model="claimant.cartonNumber"></el-input>-->
<!--          </el-form-item>-->
          <!-- 更换数量 -->
          <el-form-item :label="$t('climant.changeNum')">
            <el-input disabled v-model="claimant.changeQuantity"></el-input>
          </el-form-item>
          <!-- 维修方案 -->
          <el-form-item :label="$t('climant.wxfa')">
            <el-select v-model="claimant.repairPlan" disabled placeholder="" filterable clearable>
              <el-option :label="$t('climant.wx')" :value="0"> </el-option>
              <el-option :label="$t('climant.gh')" :value="1"> </el-option>
              <el-option :label="$t('claimantKd.bf')" :value="2"> </el-option>
            </el-select>
          </el-form-item>
          <!-- 工时 -->
          <el-form-item :label="$t('climant.manHour')">
            <el-input-number
              disabled
              v-model="claimant.workingHours"
              :controls="false"
              :precision="2"
            ></el-input-number>
          </el-form-item>
          <!-- 运费 -->
          <el-form-item :label="$t('climant.transportationCost')">
            <el-input-number
              disabled
              v-model="claimant.shippingFee"
              :controls="false"
              :precision="2"
              class="prepend-input"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimant.currency === 0 ? "￥" : "" }}
              {{ claimant.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 关税 -->
          <el-form-item :label="$t('climant.customs')">
            <el-input-number
              disabled
              v-model="claimant.tariff"
              :controls="false"
              :precision="2"
              class="prepend-input"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimant.currency === 0 ? "￥" : "" }}
              {{ claimant.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 其他费用 -->
          <el-form-item :label="$t('climant.otherCost')">
            <el-input-number
              disabled
              v-model="claimant.otherExpenses"
              :controls="false"
              :precision="2"
              class="prepend-input"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimant.currency === 0 ? "￥" : "" }}
              {{ claimant.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 管理费费率 -->
          <el-form-item :label="$t('climant.manageRate')">
            <el-input disabled v-model="claimant.managementFeeRate"></el-input>
          </el-form-item>
          <!-- 工时费用 -->
          <el-form-item :label="$t('claimantKd.gsfy')">
            <el-input-number
              disabled
              v-model="claimant.laborCost"
              :controls="false"
              :precision="2"
              class="prepend-input"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimant.currency === 0 ? "￥" : "" }}
              {{ claimant.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 材料费用 -->
          <el-form-item :label="$t('claimantKd.clfy')">
            <el-input-number
              disabled
              v-model="claimant.materialCost"
              :controls="false"
              :precision="2"
              class="prepend-input"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimant.currency === 0 ? "￥" : "" }}
              {{ claimant.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 故障件总金额 -->
          <el-form-item :label="$t('climant.faultTotalPrice')">
            <el-input-number
              disabled
              v-model="claimant.faultPartTotalPrice"
              :controls="false"
              :precision="2"
              class="prepend-input"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimant.currency === 0 ? "￥" : "" }}
              {{ claimant.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 零部件来源 -->
          <el-form-item :label="$t('climant.unitSource')">
            <el-select
              disabled
              v-model="claimant.sourceOfComponents"
              placeholder=""
              filterable clearable
            >
              <el-option :label="$t('climant.mfj')" :value="0"> </el-option>
              <el-option :label="$t('climant.gysmfj')" :value="2"> </el-option>
              <el-option :label="$t('climant.sfj')" :value="1"> </el-option>
            </el-select>
          </el-form-item>
          <!-- 其他故障件 -->
        </div>
        <div class="second-title">
          {{ $t("climant.otherFault") }}
        </div>
        <div class="table-container" style="padding: 15px 18px 0 54px">
          <el-table
            ref="tableRef"
            :data="claimant.faultPartsList"
            stripe
            border
            highlight-current-row
          >
            <!-- 序号 -->
            <el-table-column
              type="index"
              :label="$t('cart.xh')"
              width="60"
              align="center"
              :render-header="$globalRenderHeader"
            >
            </el-table-column>
            <!-- 故障件件号 -->
            <el-table-column
              prop="faultPartNumber"
              :label="$t('climant.faultNo')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
            </el-table-column>
            <!-- 故障件名称 -->
            <el-table-column
              prop="faultPartName"
              :label="$t('climant.faultName')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
            </el-table-column>
            <!-- 故障件单价 -->
            <el-table-column
              prop="faultPartUnitPrice"
              :label="$t('climant.faultPrice')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
              <template slot-scope="scope">
                <div>
                  {{ claimant.currency === 0 ? "￥" : "" }}
                  {{ claimant.currency === 1 ? "$" : "" }}
                  {{ scope.row.faultPartUnitPrice }}
                </div>
              </template>
            </el-table-column>
            <!-- 纸箱号 -->
<!--            <el-table-column-->
<!--              prop="cartonNumber"-->
<!--              :label="$t('claimantKd.zxh')"-->
<!--              align="center"-->
<!--              min-width="160px"-->
<!--              :render-header="$globalRenderHeader"-->
<!--            >-->
<!--            </el-table-column>-->
            <!-- 更换数量 -->
            <el-table-column
              prop="changeQuantity"
              :label="$t('climant.changeNum')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
            </el-table-column>
            <!-- 维修方案 -->
            <el-table-column
              prop="repairPlan"
              :label="$t('climant.wxfa')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
              <template slot-scope="scope">
                {{ scope.row.repairPlan === 0 ? $t('climant.wx') : '' }}
                {{ scope.row.repairPlan === 1 ? $t('climant.gh') : '' }}
                {{ scope.row.repairPlan === 2 ? $t('claimantKd.bf') : '' }}
              </template>
            </el-table-column>
            <!-- 工时 -->
            <el-table-column
              prop="workingHours"
              :label="$t('climant.manHour')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
            </el-table-column>
            <!-- 运费 -->
            <el-table-column
              prop="shippingFee"
              :label="$t('climant.transportationCost')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
              <template slot-scope="scope">
                <div>
                  {{ claimant.currency === 0 ? "￥" : "" }}
                  {{ claimant.currency === 1 ? "$" : "" }}
                  {{ scope.row.shippingFee }}
                </div>
              </template>
            </el-table-column>
            <!-- 关税 -->
            <el-table-column
              prop="tariff"
              :label="$t('climant.customs')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
              <template slot-scope="scope">
                <div>
                  {{ claimant.currency === 0 ? "￥" : "" }}
                  {{ claimant.currency === 1 ? "$" : "" }}
                  {{ scope.row.tariff }}
                </div>
              </template>
            </el-table-column>
            <!-- 其他费用 -->
            <el-table-column
              prop="otherExpenses"
              :label="$t('climant.otherCost')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
              <template slot-scope="scope">
                <div>
                  {{ claimant.currency === 0 ? "￥" : "" }}
                  {{ claimant.currency === 1 ? "$" : "" }}
                  {{ scope.row.otherExpenses }}
                </div>
              </template>
            </el-table-column>
            <!-- 管理费费率 -->
            <el-table-column
              prop="managementFeeRate"
              :label="$t('climant.manageRate')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
            </el-table-column>
            <!-- 工时费用 -->
            <el-table-column
              prop="laborCost"
              :label="$t('claimantKd.gsfy')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
              <template slot-scope="scope">
                <div>
                  {{ claimant.currency === 0 ? "￥" : "" }}
                  {{ claimant.currency === 1 ? "$" : "" }}
                  {{ scope.row.laborCost }}
                </div>
              </template>
            </el-table-column>
            <!-- 材料费用 -->
            <el-table-column
              prop="materialCost"
              :label="$t('claimantKd.clfy')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
              <template slot-scope="scope">
                <div>
                  {{ claimant.currency === 0 ? "￥" : "" }}
                  {{ claimant.currency === 1 ? "$" : "" }}
                  {{ scope.row.materialCost }}
                </div>
              </template>
            </el-table-column>
            <!-- 故障件总金额 -->
            <el-table-column
              prop="faultPartTotalPrice"
              :label="$t('climant.faultTotalPrice')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
              <template slot-scope="scope">
                <div>
                  {{ claimant.currency === 0 ? "￥" : "" }}
                  {{ claimant.currency === 1 ? "$" : "" }}
                  {{ scope.row.faultPartTotalPrice }}
                </div>
              </template>
            </el-table-column>
            <!-- 零部件来源 -->
            <el-table-column
              prop="sourceOfComponents"
              :label="$t('climant.unitSource')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
              <template slot-scope="scope">
                {{
                  scope.row.sourceOfComponents === 0 ? $t("climant.mfj") : ""
                }}
                {{
                  scope.row.sourceOfComponents === 2 ? $t("climant.gysmfj") : ""
                }}
                {{
                  scope.row.sourceOfComponents === 1 ? $t("climant.sfj") : ""
                }}
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 费用信息 -->
        <div class="hearder-title">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            {{ $t("climant.costInfo") }}
          </div>
        </div>
        <div class="form-container">
          <!-- 总工时 -->
          <el-form-item :label="$t('claimantKd.zgs') + '(h)'">
            <el-input-number
              disabled
              v-model="claimant.manHour"
              :controls="false"
              :min="0"
              :max="999"
              :precision="2"
            ></el-input-number>
          </el-form-item>
          <!-- 工时单价 -->
          <el-form-item :label="$t('climant.hourlyPrice')">
            <el-input-number
              disabled
              v-model="claimant.hourlyRate"
              :controls="false"
              :precision="2"
              class="prepend-input"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimant.currency === 0 ? "￥" : "" }}
              {{ claimant.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 工时总费用 -->
          <el-form-item :label="$t('claimantKd.gszfy')">
            <el-input-number
              disabled
              v-model="claimant.totalCostOfWork"
              :controls="false"
              :precision="2"
              class="prepend-input"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimant.currency === 0 ? "￥" : "" }}
              {{ claimant.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 材料总费用 -->
          <el-form-item :label="$t('claimantKd.clzfy')">
            <el-input-number
              disabled
              v-model="claimant.materialTotalCost"
              :controls="false"
              :precision="2"
              class="prepend-input"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimant.currency === 0 ? "￥" : "" }}
              {{ claimant.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 总运费 -->
          <el-form-item :label="$t('claimantKd.zyf')">
            <el-input-number
              disabled
              v-model="claimant.freight"
              :controls="false"
              :precision="2"
              class="prepend-input"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimant.currency === 0 ? "￥" : "" }}
              {{ claimant.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 总关税 -->
          <el-form-item :label="$t('claimantKd.zguanshui')">
            <el-input-number
              disabled
              v-model="claimant.tariffTotal"
              :controls="false"
              :precision="2"
              class="prepend-input"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimant.currency === 0 ? "￥" : "" }}
              {{ claimant.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 其他总费用 -->
          <el-form-item :label="$t('claimantKd.qtzfy')">
            <el-input-number
              disabled
              v-model="claimant.otherTotalCost"
              :controls="false"
              :precision="2"
              class="prepend-input"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimant.currency === 0 ? "￥" : "" }}
              {{ claimant.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 结算币种 -->
          <el-form-item :label="$t('climant.currency')">
            <el-select disabled v-model="claimant.currency" placeholder="" filterable clearable>
              <el-option label="CNY" :value="0"> </el-option>
              <el-option label="USD" :value="1"> </el-option>
            </el-select>
          </el-form-item>
          <!-- 其他总费用说明 -->
          <el-form-item :label="$t('climant.otherCostCondition')">
            <el-input disabled v-model="claimant.otherInstruction"></el-input>
          </el-form-item>
          <!-- 索赔总费用 -->
          <el-form-item :label="$t('climant.climantTotal')">
            <el-input-number
              disabled
              v-model="claimant.claimTotalCost"
              :controls="false"
              :precision="2"
              class="prepend-input"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimant.currency === 0 ? "￥" : "" }}
              {{ claimant.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
        </div>
        <!-- 附件信息 -->
        <div class="hearder-title">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            {{ $t("home.attachmentInfo") }}
          </div>
        </div>
        <div class="form-container">
          <el-form-item :label="$t('home.attachmentInfo')" prop="fileList">
            <file-upload-list
              ref="fileUploadList"
              :fileList="claimant.fileList"
            ></file-upload-list>
            <!-- <div class="file">
              <div
                class="file-list"
                style="cursor: pointer"
                v-for="(data, idx) in claimant.fileList"
                :key="idx"
              >
                <div class="left">
                  <i class="el-icon-document"></i
                  ><span>{{ data.fileName }}</span>
                </div>
                <div class="down-icon" v-if="data.downStatus">
                  {{ $t("operate.alreadyDown") }}
                </div>
                <div class="right" @click="downLoad(data.filePath, idx)">
                  {{ $t("home.down") }}
                </div>
                <div
                  class="right"
                  style="margin-left: 10px"
                  v-if="showViewBtn(data.fileType)"
                  @click="viewFile(data)"
                >
                  {{ $t("operate.preview") }}
                </div>
              </div>
            </div> -->
          </el-form-item>
        </div>
        <!-- 审核信息 -->
        <div v-if="claimStatementAudit?.auditType" class="hearder-title">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            <span v-if="claimStatementAudit.auditType === 6">
              {{ $t("climant.jsxx") }}
            </span>
            <span v-else-if="claimStatementAudit.auditType === 3">
              {{ $t("climant.zrqrxx") }}
            </span>
            <span v-else> {{ $t("climant.shxx") }}</span>
          </div>
        </div>
        <div v-if="claimStatementAudit.auditType" class="form-container">
          <!-- 流程环节 -->
          <el-form-item :label="$t('climant.lchj')">
            <el-input disabled v-model="claimStatementAudit.auditType" />
          </el-form-item>
          <!-- 流程结果 -->
          <el-form-item
            v-if="
              !(
                claimStatementAudit.auditType == $t('seek.submit') ||
                claimStatementAudit.auditType == $t('message.js') ||
                claimStatementAudit.auditType == $t('message.cancel') ||
                claimStatementAudit.auditType == $t('message.revocate')
              )
            "
            :label="$t('climant.lcjg')"
          >
            <el-input disabled v-model="claimStatementAudit.status"></el-input>
          </el-form-item>
          <!-- 驳回原因 -->
          <el-form-item
            v-if="claimStatementAudit['remark' + $i18n.locale]"
            :label="$t('zlfk.bhyy')"
          >
            <el-input
              disabled
              v-model="claimStatementAudit['remark' + $i18n.locale]"
            ></el-input>
          </el-form-item>
          <!-- 操作人 -->
          <el-form-item :label="$t('climant.czry')">
            <el-input
              disabled
              v-model="claimStatementAudit.staffName"
            ></el-input>
          </el-form-item>
          <!-- 操作时间 -->
          <el-form-item :label="$t('climant.czsj')">
            <el-input
              disabled
              v-model="claimStatementAudit.createTime"
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div v-else class="record_info">
      <!-- 查看记录 -->
      <div class="hearder-title">
        <div class="flex_between">
          <img
            class="title-icon"
            src="@/assets/img/title-icon.svg"
            alt="dark"
          />
          {{ $t("climant.lsjl") }}
          <el-button
            style="margin-left: 20px"
            type="primary"
            class="primary-btn"
            size="mini"
            @click="handleViewRecord('detail')"
            >{{ $t("zlfk.backto") }}</el-button
          >
        </div>
      </div>
      <div class="form-container">
        <audit-record :recordList="recordList" />
      </div>
    </div>
    <div class="flex_default_center" v-if="$route.query.messageId">
      <el-button
        v-if="
          claimant.status === 0 ||
          claimant.status === 2 ||
          claimant.status === 4 ||
          claimant.status === 9
        "
        size="small"
        class="primary-btn"
        type="primary"
        @click="handleReEdit"
      >
        {{ $t("climant.reEdit") }}
      </el-button>
      <el-button size="small" class="primary-btn" type="primary" @click="back">
        {{ $t("zlfk.backto") }}
      </el-button>
    </div>
    <view-img-video ref="viewRef" :list="previewList" />
  </div>
</template>
<script>
import { getStorage, getSession, setStorageNew } from "@/util/localStor";
import { readMsg } from "@/api/part";
import TranslateBtn from "@/components/translateBtn";
import AuditRecord from "./auditRecord.vue";
import { auditHistoryList, claimantList, messageReading } from "@/api/seek";
import { getDictItem, getDictValue } from "@/util/dict";
import ViewImgVideo from "@/components/viewImgVideo.vue";

export default {
  components: { TranslateBtn, AuditRecord, ViewImgVideo },
  data() {
    return {
      previewList: [],
      partMajorList: [
        {
          name: "车身",
          id: 1,
        },
        {
          name: "底盘",
          id: 2,
        },
        {
          name: "电器",
          id: 3,
        },
        {
          name: "内外饰",
          id: 4,
        },
        {
          name: "新能源",
          id: 5,
        },
        {
          name: "动力",
          id: 6,
        },
      ], // 零部件专业
      fileList: [],
      claimant: {},
      tableData: [
        {
          id: 1,
          num: "A006-Q123-98",
          name: "车窗",
          price: "86",
          fl: "0.5",
          sl: "1",
          total: "865",
          isErr: "是",
        },
      ],
      pageIndex: "detail", // 详情 | 记录
      recordList: [],
      claimStatementAudit: {
        auditType: "",
      },
      exchangeRate: "",
    };
  },
  watch: {
    // 语言切换时，清空表单验证
    "$i18n.locale": function () {
      this.getAuditLocale();
    },
  },
  async mounted() {
    this.claimant = getStorage("claimantData");
    // if (this.claimant.repairPlan == 0) {
    //   this.claimant.sourceOfComponents = 0;
    //   this.claimant.changeQuantity = 0;
    //   this.claimant.faultPartsList?.map((item, index) => {
    //     item.sourceOfComponents = 0;
    //     item.changeQuantity = 0;
    //     item.faultPartTotalPrice = 0;
    //   });
    //   this.$set(this.claimant, "faultPartTotalPrice", 0);
    //   this.$set(
    //     this.claimant,
    //     "totalCostOfWork",
    //     this.claimant.manHour * this.claimant.hourlyRate
    //   );
    //   this.$set(
    //     this.claimant,
    //     "claimTotalCost",
    //     Number(this.claimant.totalCostOfWork) +
    //       Number(this.claimant.materialTotalCost) +
    //       Number(this.claimant.otherTotalCost) +
    //       Number(this.claimant.freight) +
    //       Number(this.claimant.tariff)
    //   );
    // }
    this.previewList = this.claimant.fileList?.filter((item) => {
      return "image,video".indexOf(item.fileType.slice(0, 5)) !== -1;
    });
    this.getExchangeRate();
    if (this.$route.query?.messageId && this.$route.query?.claimantId) {
      // 将未读消息改为已读
      if (!(this.$route.query?.messageStatus == 1)) {
        messageReading({
          data: { messageList: [this.$route.query?.messageId] },
        });
      }
      const res = await claimantList({
        data: {
          claimStatementNum: this.$route.query?.claimantId,
        },
        page: {
          pageNum: 1,
          pageSize: 1,
        },
      });
      if (res.status == 0) {
        this.claimant = res.data.records[0] || {};
      } else {
        this.$DonMessage.error(res.message);
      }
    }

    if (this.$route.query && this.$route.query.unread > 0) {
      this.readDetail();
    }
    const res = await auditHistoryList({
      data: { claimStatementId: this.claimant.claimStatementId },
    });
    this.recordList = res.data;
    this.$nextTick(() => {
      if (this.recordList.length > 0) {
        this.getAuditLocale();
      }
    });
  },
  methods: {
    // 审核记录多语言处理
    getAuditLocale() {
      // this.claimStatementAudit = JSON.parse(
      //   JSON.stringify(this.claimant.claimStatementAudit || {})
      // );
      let arr = JSON.parse(JSON.stringify(this.recordList));
      this.claimStatementAudit = arr.slice(-1)[0];
      // if (this.claimant?.claimStatementAudit?.auditType === 0) {
      if (this.claimStatementAudit?.auditType === 0) {
        this.claimStatementAudit.auditType = this.$t("message.sh");
      }
      if (this.claimStatementAudit?.auditType === 1) {
        this.claimStatementAudit.auditType = this.$t("message.sh");
      }
      if (this.claimStatementAudit?.auditType === 3) {
        this.claimStatementAudit.auditType = this.$t("message.zrqr");
      }
      if (this.claimStatementAudit?.auditType === 5) {
        this.claimStatementAudit.auditType = this.$t("seek.submit");
      }
      if (this.claimStatementAudit?.auditType === 6) {
        this.claimStatementAudit.auditType = this.$t("message.js");
      }
      if (this.claimStatementAudit?.auditType === 7) {
        this.claimStatementAudit.auditType = this.$t("message.cancel");
      }
      if (this.claimStatementAudit?.auditType === 8) {
        this.claimStatementAudit.auditType = this.$t("operate.revocate");
      }
      if (this.claimStatementAudit?.auditType === 9) {
        this.claimStatementAudit.auditType = this.$t("climant.secondFill");
      }
      if (this.claimStatementAudit?.auditType === 11) {
        this.claimStatementAudit.auditType = this.$t("operate.revocate");
      }
      if (this.claimStatementAudit?.status === 1) {
        this.claimStatementAudit.status = this.$t("home.passed");
      }
      if (this.claimStatementAudit?.status === 2) {
        this.claimStatementAudit.status = this.$t("zlfk.bty");
      }
      if (this.claimStatementAudit?.status === 3) {
        this.claimStatementAudit.status = this.$t("message.bh");
      }
      if (this.claimStatementAudit?.status === 4) {
        this.claimStatementAudit.status = this.$t("message.jp");
      }
      if (this.claimStatementAudit?.status === 5) {
        this.claimStatementAudit.status = this.$t("zlfk.clz");
      }
      if (this.claimStatementAudit?.status === 6) {
        this.claimStatementAudit.status = this.$t("message.yspass");
      }
      if (this.claimStatementAudit?.status === 7) {
        this.claimStatementAudit.status = this.$t("climant.ych");
      }
      if (this.claimStatementAudit?.status === 8) {
        this.claimStatementAudit.status = this.$t("home.canceled");
      }
    },
    // 获取汇率
    async getExchangeRate() {
      const exchangeRateDict = await getDictItem("exchangeRate");
      const exchangeRateItem = getDictValue(exchangeRateDict, "USD/CNY");
      this.exchangeRate = exchangeRateItem?.codeText || this.exchangeRate;
    },
    back() {
      this.$router.go(-1);
    },
    // 获取翻译值
    getTranslateVal(field, value) {
      this.$set(this.claimant, field, value);
    },
    // 详情 | 记录
    handleViewRecord(index) {
      this.pageIndex = index;
    },
    async readDetail() {
      const query = {
        data: {
          dataId: this.claimant.claimStatementId,
          customerId: getSession("person").customerId,
          notificationType: 2,
        },
      };
      const res = await readMsg(query);
      this.$store.state.refresh = new Date().getTime();
    },
    // 下载
    downLoad(url, index) {
      this.$set(this.claimant.fileList[index], "downStatus", true);
      window.open(url);
    },
    showViewBtn(type) {
      const fileExtension = type.slice(0, 5);
      return "image,video".indexOf(fileExtension) !== -1;
    },
    // 预览
    viewFile(data) {
      this.$refs.viewRef.init(data);
    },
    // 重新编辑
    handleReEdit() {
      setStorageNew("claimantData", this.claimant);
      this.$router.push("/newClaimant");
    },
  },
};
</script>
<style lang="scss" scoped>
.seek_detail_page {
  // padding-bottom: 20px;
  padding: 0 !important;
  ::v-deep .el-input {
    // width: 300px;
  }
  .top-container {
    padding: 10px 32px 10px 14px;
    border-bottom: 5px solid #efefef;
    .split {
      margin: 0 10px 0 7px;
      border: 1px solid #dde0e8;
      height: 18px;
    }
  }
  .status-container {
    display: flex;
    align-items: baseline;
    padding: 13px 44px;
    border-bottom: 1px solid #dcdee0;
    .status {
      margin: 0 85px;
    }
    .btn {
      padding: 0;
      font-size: 16px;
    }
  }
  .hearder-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    color: #333333;
    padding: 14px 10px 14px 20px;
    border-bottom: 1px solid #dcdee0;
    .title-icon {
      margin-right: 10px;
    }
    .flex_between{
      display: flex !important;
    }
    p {
      font-size: 16px;
      color: #4095e5;
      font-weight: bold;
      i {
        font-size: 18px;
        color: #4095e5;
        display: inline-block;
        margin-right: 5px;
      }
    }
  }
  .second-title {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #bd3124;
    padding: 22px 10px 10px 62px;
    border-bottom: 1px solid #dcdee0;
  }
  .form-container {
    margin-top: 34px;
    padding: 0 60px;
  }
  .number-input {
    ::v-deep .el-input__inner {
      // text-align: left;
    }
  }
  .number-input-prepend {
    // background-color: #f5f7fa;
    // color: #909399;
    // border-right: 1px solid #dcdfe6;
    // vertical-align: middle;
    // border-radius: 4px 0 0 4px;
    // display: inline-block;
    // height: 38px;
    // line-height: 38px;
    // width: 40px;
    // text-align: center;
    // position: absolute;
    // left: 1px;
    // top: 60%;
    // transform: translateY(-60%);
  }
  .prepend-padding {
    ::v-deep .el-input__inner {
      // padding-left: 55px;
    }
  }
  .fanyi-box {
    ::v-deep .el-textarea__inner {
      height: 100px;
    }
    .textAreaTipBtn {
      cursor: pointer;
      width: fit-content;
      color: #bd3124;
    }
  }
}
.file {
  .down-icon {
    margin-left: 10px;
    color: #1890ff;
  }
  // width: 100%;
  .file-list {
    // background: #eee;
    margin: 0 10px;
    padding: 0 5px;
    // width: 200px;
    box-sizing: border-box;
    border-radius: 3px;
    display: flex;
    // justify-content: center;
    align-items: center;
    cursor: pointer;
    display: flex;
    i {
      font-size: 20px;
    }
    span {
      display: inline-block;
      font-size: 12px;
      margin-left: 5px;
    }
    .right {
      font-size: 12px;
      padding: 0 5px;
      border: 1px solid #4095e5;
      text-align: center;
      margin-left: 30px;
      border-radius: 6px;
      height: 26px;
      line-height: 26px;
      box-sizing: border-box;
      opacity: 0;
    }
  }
  .file-list:hover {
    background: rgb(243, 246, 249);
    color: #4095e5;
    .right {
      opacity: 1;
    }
  }
}
.red_label {
  color: red;
  font-weight: bold;
}
</style>
<style lang="scss">
.el-tooltip__popper {
  max-width: 400px;
}
</style>
